import { SettingsKeys } from '@/i18n/types';

export const settings: Record<SettingsKeys, string> = {
  settings: 'Settings',
  account: 'Account',
  profile: 'Profile',
  preferences: 'Preferences',
  theme: 'Theme',
  darkMode: 'Dark Mode',
  lightMode: 'Light Mode',
  notifications: 'Notifications',
  privacy: 'Privacy',
  termsOfService: 'Terms of Service',
  faq: 'FAQ',
  support: 'Support',
  logout: 'Logout',
  deleteAccount: 'Delete Account',
  confirmDeleteAccount: 'Confirm Delete Account',
  userProfile: 'User Profile',
  pleaseLoginToViewProfile: 'Please login to view your profile',
  authRequired: 'Authentication Required',
  profileUpdated: 'Profile Updated',
  profileSectionUpdated: '{section} information updated successfully',
  updateError: 'Update Error',
  couldNotUpdateProfile: 'Could not update your profile',
  errorLoadingProfile: 'Error Loading Profile',
  tryRefreshPage: 'Please try refreshing the page',
  tryAgainLater: 'Please try again later',
  identity: 'Identity',
  contactInfo: 'Contact Info',
  security: 'Security',
  supportAndHelp: 'Support & Help',
  name: 'Name',
  email: 'Email',
  biography: 'Biography',
  socialLinks: 'Social Links',
  noSocialLinksAdded: 'No social links added',
  website: 'Website',
  profileCompletion: 'Profile Completion',
  firstName: 'First Name',
  lastName: 'Last Name',
  tellUsAboutYourself: 'Tell us about yourself...',
  saving: 'Saving...',
  save: 'Save',
  phoneNumber: 'Phone Number',
  phone: 'Phone',
  country: 'Country',
  selectCountry: 'Select country',
  language: 'Language',
  selectLanguage: 'Select language',
  contactInfoUpdated: 'Contact information updated successfully',
  couldNotUpdateContact: 'Could not update contact information',
  emailCannotBeChanged: 'Email address cannot be changed',
  optionalForSmsNotifications: 'Optional, for SMS notifications',
  invalidPhoneNumber: 'Invalid Phone Number',
  pleaseEnterValidPhone: 'Please enter a valid phone number',
  identityInfoUpdated: 'Identity information updated successfully',
  couldNotUpdateIdentity: 'Could not update identity information',
  changePassword: 'Change Password',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  passwordMismatch: 'Password Mismatch',
  newPasswordsDoNotMatch: 'New passwords do not match',
  passwordTooShort: 'Password Too Short',
  passwordMinLength: 'Password must be at least 6 characters',
  changing: 'Changing...',
  passwordChanged: 'Password Changed',
  passwordUpdatedSuccessfully: 'Your password has been updated successfully',
  passwordChangeError: 'Password Change Error',
  couldNotChangePassword: 'Could not change your password',
  twoFactorAuthentication: 'Two-Factor Authentication',
  twoFactorEnabled: 'Two-Factor Authentication Enabled',
  twoFactorDisabled: 'Two-Factor Authentication Disabled',
  twoFactorDescription: 'Add an extra layer of security to your account with two-factor authentication',
  accountMoreSecure: 'Your account is now more secure with 2FA enabled',
  twoFactorTurnedOff: 'Two-Factor Authentication has been turned off',
  twoFactorError: 'Two-Factor Authentication Error',
  couldNotToggleTwoFactor: 'Could not toggle two-factor authentication',
  securityRecommendation: 'Security Recommendation',
  enableTwoFactorRecommendation: 'We recommend enabling two-factor authentication for enhanced account security',
  loginHistory: 'Login History',
  loggingOut: 'Logging out...',
  logoutOtherSessions: 'Log out of other sessions',
  logoutOtherSessionsConfirm: 'Yes, log out other sessions',
  logoutOtherSessionsConfirmation: 'This will end all other active sessions. Your current session will remain active.',
  otherSessionsClosed: 'Other Sessions Closed',
  successfullyLoggedOutOtherDevices: 'Successfully logged out of all other devices',
  logoutError: 'Logout Error',
  couldNotLogoutOtherSessions: 'Could not log out of other sessions',
  current: 'Current',
  errorFetchingSessions: 'Error Fetching Sessions',
  couldNotLoadSessionHistory: 'Could not load session history',
  notificationChannels: 'Notification Channels',
  emailNotifications: 'Email Notifications',
  smsNotifications: 'SMS Notifications',
  pushNotifications: 'Push Notifications',
  notificationEvents: 'Notification Events',
  messages: 'Messages',
  reminders: 'Reminders',
  promotionsAndNews: 'Promotions and News',
  profileVisibility: 'Profile Visibility',
  public: 'Public',
  onlyContacts: 'Only Contacts',
  private: 'Private',
  publicDescription: 'Your profile is visible to everyone',
  onlyContactsDescription: 'Your profile is only visible to your connections',
  privateDescription: 'Your profile is not visible to anyone',
  shareUsageData: 'Share Usage Data',
  shareUsageDataDescription: 'Help us improve by sharing anonymous usage data',
  allowAnalytics: 'Allow Analytics',
  allowAnalyticsDescription: 'Let us collect anonymous analytics to improve our services',
  appearance: 'Appearance',
  systemDefault: 'System Default',
  fontSize: 'Font Size',
  selectFontSize: 'Select font size',
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
  preferencesUpdated: 'Preferences Updated',
  yourPreferencesHaveBeenSaved: 'Your preferences have been saved successfully',
  couldNotSavePreferences: 'Could not save your preferences',
  savePreferences: 'Save Preferences',
  currentPlan: 'Current Plan',
  freePlan: 'Free Plan',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  cancelling: 'Cancelling',
  paymentMethods: 'Payment Methods',
  noPaymentMethodsYet: 'No payment methods added yet',
  addPaymentMethod: 'Add Payment Method',
  expiresOn: 'Expires on',
  edit: 'Edit',
  billingHistory: 'Billing History',
  month: 'month',
  free: 'Free',
  cancelSubscription: 'Cancel Subscription',
  cancelSubscriptionConfirmation: 'Are you sure you want to cancel your subscription?',
  cancelSubscriptionWarning: 'Your subscription will remain active until the end of the current billing period. After that, you will lose access to premium features.',
  processing: 'Processing...',
  confirmCancellation: 'Yes, Cancel Subscription',
  subscriptionCancelled: 'Subscription Cancelled',
  subscriptionWillEndOn: 'Your subscription will end on {date}',
  cancellationError: 'Cancellation Error',
  couldNotCancelSubscription: 'Could not cancel your subscription',
  managePlan: 'Manage Plan',
  upgradeToPremium: 'Upgrade to Premium',
  contactSupport: 'Contact Support',
  subject: 'Subject',
  selectSubject: 'Select a subject',
  accountIssues: 'Account Issues',
  billingInquiries: 'Billing Inquiries',
  technicalSupport: 'Technical Support',
  featureRequests: 'Feature Requests',
  other: 'Other',
  message: 'Message',
  describeProblemOrQuestion: 'Describe your problem or question...',
  supportResponseTime: 'Support typically responds within 24 hours',
  sending: 'Sending...',
  sendMessage: 'Send Message',
  messageSent: 'Message Sent',
  supportTeamWillContactYou: 'Our support team will contact you soon',
  feedback: 'Feedback',
  positive: 'Positive',
  negative: 'Negative',
  whatDoYouLike: 'What do you like about our app?',
  whatCanWeImprove: 'What can we improve?',
  shareFavoriteFeatures: 'Share your favorite features or experiences...',
  tellUsWhatToImprove: 'Tell us what we can improve...',
  submitting: 'Submitting...',
  submitFeedback: 'Submit Feedback',
  feedbackSubmitted: 'Feedback Submitted',
  thanksForYourFeedback: 'Thank you for your feedback!',
  howToChangePassword: 'How do I change my password?',
  changePasswordExplanation: 'You can change your password in the Security tab of your Profile page. You\'ll need to enter your current password and then your new password twice.',
  howToDeleteAccount: 'How can I delete my account?',
  deleteAccountExplanation: 'To delete your account, please contact our support team. All your data will be permanently removed.',
  whatIsSubscriptionCancelPolicy: 'What is the subscription cancellation policy?',
  subscriptionCancelPolicyExplanation: 'You can cancel your subscription at any time. Your subscription will remain active until the end of the current billing period.',
  canIExportMyData: 'Can I export my data?',
  exportDataExplanation: 'Yes, you can export your data from the settings page. We provide exports in common formats like CSV and PDF.',
  howToCreateNewBudget: 'How do I create a new budget?',
  createNewBudgetExplanation: 'Navigate to the Finance section, select the Budgets tab, and click on "Create New Budget" button.',
  isMyDataSecure: 'Is my data secure?',
  dataSecurityExplanation: 'Yes, we use industry-standard encryption and security practices to keep your data safe. We never share your personal information with third parties.',
  viewFullDocumentation: 'View Full Documentation',
  
  // Add new monetization translations
  siteSettings: 'Site Settings',
  monetization: 'Monetization',
  monetizationDescription: 'Upload files required for site monetization like ads.txt, verification files, etc.',
  uploadMonetizationFile: 'Upload Monetization File',
  selectFile: 'Select File',
  chooseFile: 'Choose file',
  fileUploadHint: 'Upload files like ads.txt, monetization verification files, etc.',
  fileName: 'File Name (will be visible at the root of your site)',
  fileNameHint: 'This will be the name of the file at the root of your site: yourdomain.com/filename.txt',
  upload: 'Upload',
  uploading: 'Uploading...',
  uploadSuccess: 'Upload Successful',
  uploadError: 'Upload Error',
  fileAccessibleAt: 'File accessible at',
  errorUploadingFile: 'Error uploading file. Please try again.',
  pleaseSelectFile: 'Please select a file and provide a name',
  
  // New Features translations
  features: 'Features',
  featureManagement: 'Feature Management',
  featureKey: 'Key',
  featureName: 'Name',
  featureDescription: 'Description',
  premiumFeature: 'Premium Feature',
  addFeature: 'Add Feature',
  editFeature: 'Edit Feature',
  deleteFeature: 'Delete Feature',
  deleteFeatureConfirm: 'Are you sure you want to delete this feature? This action cannot be undone.',
  featureCreated: 'Feature Created',
  featureUpdated: 'Feature Updated',
  featureDeleted: 'Feature Deleted',
  errorFetchingFeatures: 'Error loading features',
  errorCreatingFeature: 'Error creating feature',
  errorUpdatingFeature: 'Error updating feature',
  errorDeletingFeature: 'Error deleting feature',
  keyRequired: 'Key is required',
  nameRequired: 'Name is required',
  keyAlreadyExists: 'This key already exists',
  manageFeatures: 'Manage Features',
  featureKeyTooltip: 'Unique identifier used in code',
  featureNameTooltip: 'Name shown to users',
  featureDescriptionTooltip: 'Description of the functionality',
  isPremiumTooltip: 'Indicates if the feature is only for premium users',
};
